export default function FooterSection() {
  return (
    <footer className="relative bg-foreground-900 px-4 md:px-6 py-20 md:py-24">
      <div className="max-w-[1140px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-16">
          <div className="flex-1 max-w-[520px]">
            <div className="flex items-start gap-8">
              <div className="flex-shrink-0 w-[140px] h-[170px] rounded-[20px] overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20interior%20architectural%20geometric%20light%20study%2C%20dark%20muted%20tones%2C%20warm%20charcoal%20gradients%2C%20soft%20diffused%20lighting%2C%20minimalist%20composition%2C%20no%20people%20no%20text%2C%20modern%20corporate%20atmosphere%2C%20elegant%20abstract%20forms%2C%20subtle%20texture%2C%20clean%20lines&width=280&height=340&seq=darius-footer-visual&orientation=portrait"
                  alt="Abstract architectural light study representing precision and technical excellence"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col justify-center">
                <p className="font-heading text-2xl md:text-3xl font-light italic text-white/80 leading-relaxed mb-1">
                  Precision in
                </p>
                <p className="font-heading text-2xl md:text-3xl font-light italic text-white/80 leading-relaxed mb-1">
                  every detail.
                </p>
                <p className="font-heading text-2xl md:text-3xl font-light italic text-white/80 leading-relaxed">
                  Excellence in
                </p>
                <p className="font-heading text-2xl md:text-3xl font-light italic text-white/80 leading-relaxed">
                  every decision.
                </p>
              </div>
            </div>
          </div>

          <div className="flex-shrink-0">
            <p className="font-label text-xs font-medium tracking-[0.1em] uppercase text-white/40 mb-5">Contact</p>
            <address className="not-italic space-y-1 font-body text-sm text-white/70 leading-relaxed">
              <p>Siltnamiu g. 6</p>
              <p>Babtai, 54334</p>
              <p>Lithuania</p>
              <p className="pt-3">+370 66803860</p>
              <p>ceo@dariusdigital.com</p>
            </address>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <span className="w-5 h-5 bg-white/15" style={{ clipPath: 'polygon(0 0, 100% 0, 100% 60%, 60% 100%, 0 100%)' }} />
            <span className="w-4 h-4 bg-white/10" style={{ clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0 100%, 0 30%)' }} />
          </div>
          <p className="font-heading text-base italic text-white/30">
            &copy; {new Date().getFullYear()} All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}